import { getLiveChatSessionData } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import type { ILwiContext, ILiveChatSessionDataResponse } from '@/interfaces/entities/livechat.interface';

export const LiveChatServices = {
  /**
   * Get chat session data from sitecore 10
   * @returns
   */
  getLiveChatSessionData(model: ILwiContext): Promise<ILiveChatSessionDataResponse> {
    return _http.HttpPost(`${getLiveChatSessionData}`, model);
  },
} as const;
